import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Categories from "@/pages/Categories";
import Inventory from "@/pages/Inventory";
import LowStock from "@/pages/LowStock";
import Sales from "@/pages/Sales";
import Purchases from "@/pages/Purchases";
import Customers from "@/pages/Customers";
import Suppliers from "@/pages/Suppliers";
import Users from "@/pages/Users";
import Payments from "@/pages/Payments";
import Invoice from "@/pages/Invoice";
import Receipt from "@/pages/Receipt";
import Files from "@/pages/Files";
import OrderDetail from "@/pages/OrderDetail";
import AuthCallback from "@/pages/AuthCallback";

function Shell({ children, page }) {
    return (
        <ProtectedRoute page={page}>
            <Layout>{children}</Layout>
        </ProtectedRoute>
    );
}

// Intercepts the Google OAuth redirect (#session_id=...) BEFORE routing so
// we can process it synchronously and avoid race conditions with AuthProvider.
function AppRouter() {
    const location = useLocation();
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/"           element={<Shell page="dashboard"><Dashboard /></Shell>} />
            <Route path="/products"   element={<Shell page="products"><Products /></Shell>} />
            <Route path="/categories" element={<Shell page="categories"><Categories /></Shell>} />
            <Route path="/inventory"  element={<Shell page="inventory"><Inventory /></Shell>} />
            <Route path="/low-stock"  element={<Shell page="lowstock"><LowStock /></Shell>} />
            <Route path="/sales"      element={<Shell page="sales"><Sales /></Shell>} />
            <Route path="/orders"     element={<Shell page="orders"><Sales /></Shell>} />
            <Route path="/orders/:orderId" element={<Shell page="orders"><OrderDetail /></Shell>} />
            <Route path="/purchases"  element={<Shell page="purchases"><Purchases /></Shell>} />
            <Route path="/customers"  element={<Shell page="customers"><Customers /></Shell>} />
            <Route path="/suppliers"  element={<Shell page="suppliers"><Suppliers /></Shell>} />
            <Route path="/users"      element={<Shell page="users"><Users /></Shell>} />
            <Route path="/payments"   element={<Shell page="payments"><Payments /></Shell>} />
            <Route path="/files"      element={<Shell page="files"><Files /></Shell>} />
            <Route path="/invoice/:saleId"   element={<ProtectedRoute><Invoice /></ProtectedRoute>} />
            <Route path="/receipt/:paymentId" element={<ProtectedRoute><Receipt /></ProtectedRoute>} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
